export default __webpack_public_path__ + "static/media/bands1.95e286ba.jpg";